import * as C from '../../actionTypes/users/detail'

export const retrieveUser = (payload) => ({type: C.RETRIEVE_USER, payload })

export const changeTab = (payload) => ({type: C.CHANGE_TAB, payload})
export const changePage = (payload) => ({type: C.CHANGE_PAGE, payload})
export const deleteUser = (payload) => ({type: C.DELETE_USER, payload })
